Object.defineProperty(exports,"__esModule",{value: true});
exports.default=window.GrimoireJS&&window.GrimoireJS.lib.fundamental?window.GrimoireJS.lib.fundamental.Components.TransformComponent:undefined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/grimoirejs-fundamental/ref/Components/TransformComponent.js
// module id = 7
// module chunks = 0